<h2 mat-dialog-title class="text-center">{{ title }}</h2>

<mat-dialog-content class="mat-typography">
  <page-alert *ngIf="submittedSchedule && successSchedule" message="Agendamento realizado com sucesso" alertClass="alert-success"></page-alert>
  <page-alert *ngIf="submittedSchedule && !successSchedule" [message]="messageError" alertClass="alert-danger"></page-alert>

  <div class="p-3 mb-4 border rounded bg-light">
    <h3 class="section-title">Resumo do Agendamento</h3>
    <div class="mb-2"><strong>Procedimento:</strong> {{ procedure.name }}</div>
    <div class="mb-2"><strong>Valor:</strong> R$ {{ procedure.price_high }}</div>
    <div class="mb-2" *ngIf="!isByOrder"><strong>Horário: </strong>{{ datetime | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
    <div class="mb-2" *ngIf="isByOrder"><strong>Início do Atendimento: </strong> {{ byOrderStart | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
    <div class="mb-2"><strong>Local:</strong> {{ procedure.organization.name }}</div>
    <div class="mb-2"><strong>Endereço:</strong> {{ getAddress(address) }}</div>
    <div class="mb-2"><strong>Paciente:</strong> {{ patient.name }}</div>
    <div class="mb-2 d-flex align-items-center">
      <strong class="me-2">Telefone do paciente:</strong>
      <span *ngIf="!editingPhone">{{ formatPhone(patient.phone) }}</span>

      <mat-form-field *ngIf="editingPhone" appearance="outline" class="w-auto">
        <mat-label>Telefone</mat-label>
        <input matInput name="phone" [(ngModel)]="patient.phone" #phoneInput="ngModel" prefix="55 " mask="(00) 0 0000-0000" required />
        <mat-error *ngIf="!validatePhone(patient.phone) && phoneInput.touched">
          {{ phoneInput.errors?.['required'] ? 'O telefone e obrigatorio.' : 'Formato de telefone inválido.' }}
        </mat-error>
      </mat-form-field>

      <button mat-icon-button color="primary" (click)="toggleEditPhone()">
        <mat-icon>{{ editingPhone ? 'check' : 'edit' }}</mat-icon>
      </button>
    </div>
  </div>

  <div class="p-3 mb-4 border rounded bg-white">
    <h3 class="section-title">Profissional de Saúde</h3>
    <div>{{ practitioner?.name || 'Nao informado' }}</div>
  </div>

  <div *ngIf="type === 'Exame'" class="p-3 mb-4 border rounded bg-white">
    <h3 class="section-title">Orientações do Exame</h3>
    <div [innerHTML]="procedure.extraDetails"></div>
  </div>

  <div class="p-3 mb-4 border rounded bg-white">
    <h3 class="section-title">Forma de Pagamento(*)</h3>
    <p *ngIf="paymentSettingsLoaded && !hasOnlinePaymentMethods" class="text-muted">
      A organização não configurou nenhum método de pagamento online. Apenas o pagamento presencial está disponível.
    </p>
    <div class="row gy-3">
      <div class="col-md-6" *ngIf="schedule.scheduling_method === 'PARTICULAR'">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Forma de Pagamento(*)</mat-label>
          <mat-select [(ngModel)]="schedule.paymentMethod" required>
            <mat-option *ngFor="let method of paymentMethods" [value]="method.name">
              {{ getPaymentMethodLabel(method.name) }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!isPaymentMethodAvailable(schedule.paymentMethod)"> Selecione uma forma de pagamento válida. </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="mt-3 px-3 pb-3">
  <button mat-button [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button color="primary" (click)="saveSchedule()" [disabled]="!canSaveSchedule()">Agendar</button>
</mat-dialog-actions>
